// Хук для Health Dashboard системы доступов RLS
import { useQuery } from '@tanstack/react-query'
import { fetchAccessHealth } from '@/api/accessHealth'

/**
 * Загружает данные health dashboard.
 * Обновляется каждые 60 секунд (staleTime).
 */
export const useAccessHealth = () =>
  useQuery({
    queryKey: ['access-health'],
    queryFn: fetchAccessHealth,
    staleTime: 60_000, // 1 минута
    retry: 1,
  })
